import {PlayableType} from "../../global/types/GlobalTypes";

export class TemporalIndicators {
  readonly startDivision: number;
  readonly duration: number;

  readonly divisionPerBeat: number;
  readonly beatPerMeasure: number;
  readonly tempo: number;

  // -1 when not in a parent timelines | TODO: If there is more divergence between parts / part & Challenge / Version shoud consider using different models
  readonly indexInParentTimeline: number = -1;

  get endDivision() {
    return this.startDivision + this.duration;
  }

  constructor(startDivision: number = 0, duration: number = 100, divisionPerBeat: number = 4, beatPerMeasure = 4, tempo: number = 120, indexInParentTimeline: number = -1) {
    this.startDivision = startDivision;
    this.duration = duration ;
    this.divisionPerBeat = divisionPerBeat;
    this.beatPerMeasure = beatPerMeasure;
    this.tempo = tempo;
    this.indexInParentTimeline = indexInParentTimeline;
  }

  static fromBaseTemporalIndicators(baseTemporalIndicator: TemporalIndicators, startDivision: number, indexInParentTimeline: number, duration = baseTemporalIndicator.duration) {
    return new TemporalIndicators(startDivision, duration, baseTemporalIndicator.divisionPerBeat, baseTemporalIndicator.beatPerMeasure, baseTemporalIndicator.tempo, indexInParentTimeline)
  }
}

// TODO: If there is more divergence between parts / part & Challenge / Version shoud consider using different models; for now only in temporalIndicators
export abstract class AbstractPlayableContent {
  readonly playableType: PlayableType;
  readonly id: number;
  readonly name: string;

  readonly baseModel: any;
  readonly temporalIndicators: TemporalIndicators;

  /* if current content is composed of other PlayableContent, for instance, version is composed of parts */
  readonly playableTimeline: AbstractPlayableContent[];

  protected constructor(playableType: PlayableType, id: number, name: string, temporalIndicators: TemporalIndicators, baseModel: any, playableTimeline = [] as AbstractPlayableContent[]) {
    this.playableType = playableType;
    this.id = id;
    this.name = name;

    this.temporalIndicators = temporalIndicators;
    this.baseModel = baseModel;

    this.playableTimeline = playableTimeline;
  }

  public isEmpty() {
    return this.temporalIndicators.duration > 0;
  }

  get successModalName() {
    return this.name;
  }
}
